export const INSPECTOR_LIST = [
  {
    id: "1",
    name: "Babar Hussain",
    company: "U Energy (Yorkshire) Ltd",
    address: "Greenfield House 31 East Street Lindley Huddersfield HD3 3ND",
    phone: "01484 466241",
    email: "sales@uenergygroup.co.uk",
  },
  {
    id: "2",
    name: "Sarah Smith",
    company: "SafeCheck Ltd.",
    address: "45 Industrial Ave, Metropolis",
    phone: "+1 987 654 321",
    email: "sarah@safecheck.com",
  },
];
